import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Header from './Header';
import { Outlet } from 'react-router-dom';
import userService from '../services/userService';

const Layout = () => {
	const [isLoading, setIsLoading] = useState(true);
	useEffect(() => {
		if (userService.isLogged()) {
			setIsLoading(false);
		} else {
			userService.logOut();
		}
	}, []);
	return (
		<>
			{!isLoading && (
				<>
					<Header />
					<Main>
						<Outlet />
					</Main>
				</>
			)}
		</>
	);
};
export default Layout;

const Main = styled.main`
	background-color: ${props => props.theme.body};
	color: ${props => props.theme.fontColor};
	padding-top: 100px;
	min-height: calc(100vh);
	padding: 90px 5% 50px 5%;
	transition: 0.2s all ease-in;
	&.open {
		padding-left: calc(5% + 120px);
	}
`;
